import { useDispatch, useSelector } from "react-redux";
import { get, size } from "lodash";

// import { getLoginData } from "../../selector/auth.selector";
// import { getSelectedVisit } from "../../selector/visits.selector";
// import { getVisitPagesData } from "../../selector/visitDetails.selector";
import { useCallback, useState } from "react";
import Api from "../../../utils/api.utils";
import Joi from "joi";
// import en from "../../../language/en";
import { URL, apiURL } from "../../../utils/constant";
import { toast } from "react-toastify";
import { getApiData } from "../../selector/auth.selector";
import { getSelectedVisit } from "../../selector/visits.selector";
import { getSelectedList } from "../../selector/bloodSugarRecord.selector";
import { setHypoFlag } from "../../reducer/hypoglycemia.reducer";
import { useNavigate } from "react-router-dom";
import { English } from "../../../Languages/en";
import { getLanguage } from "../../selector/language.selector";

export function useHypoglycemia() {
  const loginData = useSelector(getApiData);
  const selectedVisit = useSelector(getSelectedVisit);
  const Language = useSelector(getLanguage);

  const [loading, setLoading] = useState(false);
  const [flag, setFlage] = useState(false);
  const listData = useSelector(getSelectedList);

  const handleFlagChange = () => {
    setFlage((prevFlag) => !prevFlag);
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedListData = {};
  listData?.ItemList?.forEach((item) => {
    selectedListData[item?.ItemId] = item?.ItemValue;
  });
  selectedListData["RowNum"] = listData?.RowNum;

  const submitHypoData = useCallback(
    async ({
      otValue,
      date,
      time,
      bsValue,
      symptoms,
      reactionRecognizedBy,
      treatment,
      pageId,
      day,
    }) => {
      try {
        setLoading(true);
        const selectedReactionRecognizedBy =
          English.HypoglycemiaTitles.Reaction_Recognized_By_Options.find(
            (item) => {
              return item.value === reactionRecognizedBy;
            }
          )?.text;

        const getSymptomsTextArray = (valueString, options) => {
          const valuesArray = valueString.split("¥");
          const textArray = valuesArray
            .map((value) => {
              const symptom = options.find((option) => option.value === value);
              return symptom ? symptom.text : "";
            })
            .filter((text) => text !== ""); // Filter out any null values if no matching text is found

          return textArray.join("¥");
        };

        const selectedSymtomps = getSymptomsTextArray(
          symptoms,
          English.HypoglycemiaTitles.Symptoms_Options
        );
        const selectedTreatment = getSymptomsTextArray(
          treatment,
          English.HypoglycemiaTitles.Treatment_options
        );

        const { data } = await Api.post({
          url: apiURL.submitData(),
          data: prepareDataForSubmission({
            otValue,
            date,
            time,
            bsValue,
            selectedSymtomps,
            selectedReactionRecognizedBy,
            selectedTreatment,
            pageId,
            day,
          }),
        });

        handleResponse(data);
        setLoading(false);
        dispatch(setHypoFlag(false));
        return true;
      } catch (err) {
        console.log("submit hypo ERROR ::  ", err);
        setLoading(false);
        return false;
      }
    }
  );

  const updateHypoData = useCallback(
    async ({
      otValue,
      date,
      time,
      bsValue,
      symptoms,
      reactionRecognizedBy,
      treatment,
      pageId,
      day,
    }) => {
      try {
        setLoading(true);

        const selectedReactionRecognizedBy =
          English.HypoglycemiaTitles.Reaction_Recognized_By_Options.find(
            (item) => {
              return item.value === reactionRecognizedBy;
            }
          )?.text;

        const getSymptomsTextArray = (valueString, options) => {
          const valuesArray = valueString.split("¥");
          const textArray = valuesArray
            .map((value) => {
              const treatment = options.find(
                (option) => option.value === value
              );
              return treatment ? treatment.text : null;
            })
            .filter((text) => text !== null); // Filter out any null values if no matching text is found

          return textArray.join("¥");
        };

        const selectedSymtomps = getSymptomsTextArray(
          symptoms,
          English.HypoglycemiaTitles.Symptoms_Options
        );
        const selectedTreatment = getSymptomsTextArray(
          treatment,
          English.HypoglycemiaTitles.Treatment_options
        );
        const { data } = await Api.post({
          url: apiURL.updateFormData(),
          data: prepareDataForUpdate({
            otValue,
            date,
            time,
            bsValue,
            selectedSymtomps,
            selectedReactionRecognizedBy,
            selectedTreatment,
            pageId,
            day,
          }),
        });

        handleResponse(data);
        setLoading(false);
        dispatch(setHypoFlag(false));
        return true;
      } catch (err) {
        console.log("update Hypo ERROR ::  ", err);
        setLoading(false);
        return false;
      }
    }
  );

  const prepareDataForSubmission = ({
    otValue,
    date,
    time,
    bsValue,
    selectedSymtomps,
    selectedReactionRecognizedBy,
    selectedTreatment,
    pageId,
    day,
  }) => {
    const formattedDate = String(date);
    const subjectId = get(loginData, "SubjectId", "");
    const siteId = get(loginData, "SiteId", "");
    const trialId = get(loginData, "TrialId", "");
    const visitNo = String(get(selectedVisit, "VisitNo", ""));
    const visitId = get(selectedVisit, "VisitId", "");
    const visitCode = String(get(selectedVisit, "VisitCode", ""));
    const InvUserId = parseInt(get(loginData, "InvUserId", ""));

    return {
      AdditionalBOData: {
        ItemList: [
          {
            ItemId: "HYPO_SYM",
            ItemValue: selectedSymtomps,
            RowNum: 0,
          },
          {
            ItemId: "SUBDAY",
            ItemValue: "1",
            RowNum: 0,
          },
          {
            ItemId: "HYPO_TREAT",
            ItemValue: selectedTreatment,
            RowNum: 0,
          },
          {
            ItemId: "HYPO_TIME",
            ItemValue: time,
            RowNum: 0,
          },
          {
            ItemId: "HYPO_SYMother",
            ItemValue: otValue,
            RowNum: 0,
          },
          {
            ItemId: "BS_VALUE",
            ItemValue: bsValue,
            RowNum: 0,
          },
          {
            ItemId: "HYPO_REACT",
            ItemValue: selectedReactionRecognizedBy,
            RowNum: 0,
          },
          {
            ItemId: "HYPO_DATE",
            ItemValue: formattedDate,
            RowNum: 0,
          },
          {
            ItemId: "HYPO_DAY",
            ItemValue: `Day ${day}`,
            RowNum: 0,
          },
        ],
        PageId: pageId,
        SiteId: siteId,
        SubjectId: subjectId,
        TrialId: trialId,
        UserID: InvUserId,
        VisitCode: visitCode,
        VisitId: visitId,
        VisitNo: visitNo,
      },
    };
  };

  const prepareDataForUpdate = ({
    otValue,
    date,
    time,
    bsValue,
    selectedSymtomps,
    selectedReactionRecognizedBy,
    selectedTreatment,
    pageId,
    day,
  }) => {
    const formattedDate = String(date);
    const subjectId = get(loginData, "SubjectId", "");
    const siteId = get(loginData, "SiteId", "");
    const trialId = get(loginData, "TrialId", "");
    const visitNo = String(get(selectedVisit, "VisitNo", ""));
    const visitId = get(selectedVisit, "VisitId", "");
    const visitCode = String(get(selectedVisit, "VisitCode", ""));
    const InvUserId = parseInt(get(loginData, "InvUserId", ""));

    const updatedData = {
      AdditionalBOData: {
        ItemList: [],
        PageId: pageId,
        SiteId: siteId,
        SubjectId: subjectId,
        TrialId: trialId,
        UserID: InvUserId,
        VisitCode: visitCode,
        VisitId: visitId,
        VisitNo: visitNo,
      },
    };
    const otherSymtomp = selectedSymtomps?.split("¥").map((item) => {
      if (item === "other") {
        return item === "other";
      } else if (item === "otro") {
        return item === "otro";
      } else {
        return false;
      }
    });
    if (!otherSymtomp.includes(true)) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "HYPO_SYMother",
        ItemValue: "",
        RowNum: selectedListData?.RowNum,
      });
    } else if (selectedListData?.HYPO_SYMother !== otValue) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "HYPO_SYMother",
        ItemValue: otValue,
        RowNum: selectedListData?.RowNum,
      });
    }

    if (selectedListData?.HYPO_DATE !== date) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "HYPO_DATE",
        ItemValue: date,
        RowNum: selectedListData?.RowNum,
      });
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "HYPO_DAY",
        ItemValue: `Day ${day}`,
        RowNum: selectedListData?.RowNum,
      });
    }

    if (selectedListData?.HYPO_TIME !== time) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "HYPO_TIME",
        ItemValue: time,
        RowNum: selectedListData?.RowNum,
      });
    }

    if (selectedListData?.BS_VALUE !== bsValue) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "BS_VALUE",
        ItemValue: bsValue,
        RowNum: selectedListData?.RowNum,
      });
    }

    if (selectedListData?.HYPO_SYM !== selectedSymtomps) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "HYPO_SYM",
        ItemValue: selectedSymtomps,
        RowNum: selectedListData?.RowNum,
      });
    }

    if (selectedListData?.HYPO_REACT !== selectedReactionRecognizedBy) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "HYPO_REACT",
        ItemValue: selectedReactionRecognizedBy,
        RowNum: selectedListData?.RowNum,
      });
    }
    if (selectedListData?.HYPO_TREAT !== selectedTreatment) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "HYPO_TREAT",
        ItemValue: selectedTreatment,
        RowNum: selectedListData?.RowNum,
      });
    }

    if (
      updatedData?.AdditionalBOData.ItemList &&
      updatedData?.AdditionalBOData.ItemList.length > 0
    ) {
      return updatedData;
    } else {
      toast.success(Language.Message.noDataChanged, {
        position: "bottom-right",
      });
      setTimeout(() => {
        navigate(URL.savedRecords);
      }, 1000);
    }
  };

  const handleResponse = (data) => {
    if (size(data) <= 0) {
      // showToast("Data Inserted Successfully!");
    } else {
      if (data.Message !== Language.Message.unableInsert) {
        toast.success(data?.Message, {
          position: "bottom-right",
        });
      }
      setTimeout(() => {
        navigate(URL.savedRecords);
      }, 1000); // Adjust the delay time as needed
    }
  };

  const handleChnagedLanguageList = (row, column, options) => {
    const itemValue = get(
      row?.ItemList.find((item) => item?.ItemId === column?.id),
      "ItemValue",
      ""
    ).split("¥");
    const matchedSymptoms = itemValue
      .map((value) =>
        options?.find((symptom) => {
          if (symptom?.english === value) {
            return symptom?.english;
          }
        })
      )
      .map((symptom) => symptom?.text)
      .join(", ");
    return matchedSymptoms;
  };

  const handleReaction = (row, column, options) => {
    const itemValue = get(
      row?.ItemList.find((item) => item?.ItemId === column?.id),
      "ItemValue",
      ""
    );
    const matchedItem = options?.find((symptom) => {
      if (symptom?.english === itemValue) {
        return symptom?.english;
      }
    });
    return matchedItem?.text;
  };

  const schema = Joi.object({
    bloodSugarValue: Joi.number().required().messages({
      "any.required": Language.error.Hypoglycemia.bloodSugarValue.empty,
      "number.base": Language.error.Hypoglycemia.bloodSugarValue.base,
    }),
    otherValue: Joi.string().allow(""),
    symptoms: Joi.array().items(Joi.string()).min(1).required().messages({
      "any.required": "At least one symptom must be selected.",
      "array.min": "At least one symptom must be selected.",
    }),
    reactionRecognizedBy: Joi.string().required().empty("").messages({
      "any.required": Language.error.Hypoglycemia.reactionRecognizedBy.required,
      "string.empty ":
        Language.error.Hypoglycemia.reactionRecognizedBy.required,
    }),
    treatment: Joi.array().items(Joi.string()).min(1).required().messages({
      "any.required": "At least one treatment must be selected.",
      "array.min": "At least one treatment must be selected.",
    }),
  });

  const otherschema = Joi.object({
    bloodSugarValue: Joi.number().required().messages({
      "any.required": Language.error.Hypoglycemia.bloodSugarValue.empty,
      "number.base": Language.error.Hypoglycemia.bloodSugarValue.base,
    }),
    otherValue: Joi.string().allow(""),
    symptoms: Joi.array().items(Joi.string()).min(1).required().messages({
      "any.required": "At least one symptom must be selected.",
      "array.min": "At least one symptom must be selected.",
    }),
    reactionRecognizedBy: Joi.string().required().empty("").messages({
      "any.required": Language.error.Hypoglycemia.reactionRecognizedBy.required,
      "string.empty ":
        Language.error.Hypoglycemia.reactionRecognizedBy.required,
    }),
    treatment: Joi.array().items(Joi.string()).min(1).required().messages({
      "any.required": "At least one treatment must be selected.",
      "array.min": "At least one treatment must be selected.",
    }),
  });
  return {
    submitHypoData,
    updateHypoData,
    selectedListData,
    loading,
    flag,
    handleFlagChange,
    handleChnagedLanguageList,
    handleReaction,
    otherschema,
    schema,
  };
}
